import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { isBrowser } from '@zapier/promotions/src/utils';

type Props = {
  skip?: boolean;
};

export const currentUserQuery = gql`
  query currentUserQuery {
    currentUser: currentUserV2 {
      id
    }
  }
`;

export const useCurrentAccountId = ({ skip }: Props = {}) => {
  const { data, error, loading: isLoading } = useQuery(currentUserQuery, {
    skip,
  });

  const response = {
    accountId: undefined,
    error: error ? 'Error loading current account ID.' : undefined,
    isLoading,
  };

  if (!data?.currentUser || !isBrowser()) {
    return response;
  }

  /**
   * This can actually return a value even if the user isn't logged in.
   * So we need to make sure the user's actually logged in before returning
   * the currentAccountId.
   */
  const currentAccountId = localStorage.getItem('currentAccountId');

  return {
    ...response,
    accountId: currentAccountId ? parseInt(currentAccountId) : undefined,
  };
};
